module.exports = {
      id: "saudi-usage",
      viewBox: "0 0 14 14",
      url: __webpack_public_path__ + "svg-sprite-3bd5c44086b3ee01fb1a36f6e1306c3d.svg#saudi",
      toString: function () {
        return this.url;
      }
    }